import { useState } from "react";
import EditButton from "../../../../CommonElements/Button/EditButton";
import CreateButton from "../../../../CommonElements/Button/CreateButton";
import PengaturanModal from "../../../../Layout/Components/PengaturanModal";
import GroupStafForm from "./GroupStafForm";

const GroupStafModal = ({ create, data, resetState }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const [title] = useState(
    create ? "Form Penambahan Group Staf" : "Edit Group Staf"
  );
  const [button] = useState(
    create ? (
      <CreateButton toggle={toggle}>Buat Group Staf Baru</CreateButton>
    ) : (
      <EditButton toggle={toggle} isIcon />
    )
  );

  return (
    <PengaturanModal
      button={button}
      title={title}
      isOpen={isOpen}
      toggle={toggle}
    >
      <GroupStafForm resetState={resetState} toggle={toggle} data={data} />
    </PengaturanModal>
  );
};

export default GroupStafModal;
